var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemArrowNs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6.618 4.088a.89.89 0 0 1 .764 0 1 1 0 0 1 .326.248l4 4.57a1.26 1.26 0 0 1 0 1.616.94.94 0 0 1-.708.335.94.94 0 0 1-.707-.335L8 7.902v10.955C8 19.49 7.553 20 7 20s-1-.51-1-1.143V7.902l-2.293 2.62c-.39.447-1.023.447-1.414 0a1.26 1.26 0 0 1 0-1.616l4-4.57a1 1 0 0 1 .325-.248M17 4c.553 0 1 .51 1 1.143v10.955l2.293-2.62c.391-.447 1.023-.447 1.414 0a1.26 1.26 0 0 1 0 1.616l-3.999 4.57a1 1 0 0 1-.326.248.89.89 0 0 1-.764 0 1 1 0 0 1-.326-.248l-3.999-4.57a1.26 1.26 0 0 1 0-1.616c.391-.447 1.023-.447 1.414 0L16 16.098V5.143C16 4.51 16.447 4 17 4"
})));
export default SvgGemArrowNs;